import React from 'react';
import InitiateNewRegistration from './InitiateNewRegistration';

import { PageProvider } from '../../context/pageContext';

const InitiateNewRegistrationContainer = () => {
  return (
    <PageProvider>
      <InitiateNewRegistration />
    </PageProvider>
  );
};

export default React.memo(InitiateNewRegistrationContainer);
